<div class="widget-container">
  
  <div class="widget-menu">
    <button mat-icon-button [matMenuTriggerFor]="widgetMenu"
      id="{{idPrefix}}btn.open-menu"
      class="float-right">
      <mat-icon>more_horiz</mat-icon>
    </button>

    <mat-menu #widgetMenu="matMenu">
      <button mat-menu-item id="{{idPrefix}}btn.configure" (click)="openSettingsModal()">
        <span>{{ 'case_widget.btn.configure' | translate }}</span>
      </button>
    </mat-menu>
  </div>

  <mat-tab-group animationDuration="0ms"
                class="smp-tab-style header-text-large mat-tab-body-wrapper-no-padding">

    <!----- CASE OVERVIEW TAB ----->

    <mat-tab label="{{ 'case_widget.btn.overview' | translate }}">
      <div class="grid-container">
        <div class="dr-flex-wrapper widget-search-row row">

          <div class="col-6">
            <search-chips *ngIf="searchCriteria"
                          [(searchTerms)]="searchCriteria.search"
                          [withSuggestions]="true"
                          [suggestionList]="suggestionList"
                          [idPrefix]="idPrefix"
                          [accent]="true"
                          (searchInputChange)="getSuggestions($event)"
                          (searchTermsChange)="getCaseOverviewData()">
            </search-chips>
          </div>

          <div class="col-3">
            <mat-form-field *ngIf="statusFilterOptions"
                            class="no-error-placeholder primary-bordered accent full-width">
              <mat-label>{{ 'case_widget.filter.status' | translate }}</mat-label>
              <mat-select id="{{idPrefix}}input.state_filter"
                          [(value)]="statusFilterSelected">
                <mat-option id="{{idPrefix}}input.state_filter.{{filter.id}}" *ngFor="let filter of statusFilterOptions.filters" [value]="filter.id">
                  {{ ('common.filter.status.' + filter.id) | translate }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-3">
            <button id="{{idPrefix}}btn.create_case"
                    class="full-width"
                    mat-flat-button color="accent"
                    style="height: 50px;"
                    (click)="newCase()">{{ 'case_widget.btn.new_case' | translate }}
            </button>
          </div>
        </div>

        <ag-grid-angular
          id="{{idPrefix}}overview"
          #agGridCaseWidget
          (columnResized)="onColumnResized($event)"
          class="ag-theme-material"
          [rowData]="rowData"
          [gridOptions]="gridOptions">
        </ag-grid-angular>

        <div class="dr-flex-wrapper" style="height: 36px; margin-top: 20px;">
          <div style="width: 20%;">
            <a id="{{idPrefix}}btn.toggle_select_all"
               mat-stroked-button
               color="primary"
               *ngIf="editMode"
               (click)="toggleSelectAllCases()">
              <span *ngIf="!selectAll">{{ 'common.btn.select_all' | translate }}</span>
              <span *ngIf="selectAll">{{ 'common.btn.de_select_all' | translate }}</span>
            </a>
          </div>

          <!-- This fills the remaining space of the current row -->
          <span class="fill-remaining-space"></span>

          <div>
            <a id="{{idPrefix}}btn.show_less"
               class="iq-link-style"
               [ngClass]="{'disabled': showLessUnAvailable}"
              (click)="!showLessUnAvailable && showLess()">{{ 'common.btn.show_less' | translate }}
            </a>
            &nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;
            <a id="{{idPrefix}}btn.show_more"
               class="iq-link-style"
               [ngClass]="{'disabled': showMoreUnAvailable}"
              (click)="!showMoreUnAvailable && showMore()">{{ 'common.btn.show_more' | translate }}
            </a>
          </div>

          <!-- This fills the remaining space of the current row -->
          <span class="fill-remaining-space"></span>

          <div style="width: 20%;">
            <!--
            <a id="{{idPrefix}}btn.copy_cases"
               mat-stroked-button
               color="primary"
               *ngIf="editMode"
               style="float: right;margin-left: 10px;"
               [disabled]="!copyDeleteButtonsActive"
               (click)="copyCases()">{{ 'case_widget.btn.copy' | translate }}
            </a>
            -->
            <a id="{{idPrefix}}btn.delete_cases"
               mat-stroked-button
               color="warn"
               *ngIf="editMode"
               style="float: right;"
               [disabled]="!copyDeleteButtonsActive"
               (click)="deleteCases()">{{ 'case_widget.btn.delete' | translate }}
            </a>
          </div>

        </div>
      </div>
    </mat-tab>


    <!----- INBOX TAB ----->

    <mat-tab *ngIf="hasInboxPermission" label="{{ 'case_widget.btn.inbox' | translate }} {{ inboxEntryCount ? '('+inboxEntryCount+')' : '' }}">
      <div class="grid-container">
        <div class="dr-flex-wrapper" style="margin-bottom: 5px; height: 36px;">
          <!-- This fills the remaining space of the current row -->
          <span class="fill-remaining-space"></span>
        </div>

        <ag-grid-angular
          id="{{idPrefix}}inbox"
          #agGridInbox
          class="ag-theme-material"
          (columnResized)="onColumnResized($event, true)"
          [gridOptions]="inboxGridOptions">
        </ag-grid-angular>

        <div class="dr-flex-wrapper" style="height: 36px; margin-top: 20px;">

          <div style="width: 20%;">
            <a id="{{idPrefix}}inbox.btn.toggle_select_all"
               mat-stroked-button
               color="primary"
               *ngIf="inboxEditMode"
               (click)="toggleSelectAllInboxEntries()">
              <span *ngIf="!inboxSelectAll">{{ 'common.btn.select_all' | translate }}</span>
              <span *ngIf="inboxSelectAll">{{ 'common.btn.de_select_all' | translate }}</span>
            </a>
          </div>

          <span class="fill-remaining-space"></span>

          <div style="width: 20%;">
            <a id="{{idPrefix}}inbox.btn.delete_selected"
               mat-stroked-button
               color="warn"
               *ngIf="inboxEditMode && hasInboxDeletePermission"
               style="float: right;"
               [disabled]="!inboxBulkButtonsActive"
               (click)="deleteSelectedInboxEntries()">{{ 'case_widget.inbox.btn.delete_selected' | translate }}
            </a>
          </div>

        </div>
      </div>
    </mat-tab>

  </mat-tab-group>
</div>
